//@ts-check
import React from 'react';
import FrameBase from '../FrameBase';
/**@param {import('./types').ContactPreviewFrameProps} props */

var ContactActivityPreview = function ContactActivityPreview(_ref) {
  var id = _ref.id,
      width = _ref.width,
      height = _ref.height;
  var url = 'embed/ContactPreview/#Activity/' + id;

  var onEvent = function onEvent(event) {
    switch (event.action) {
      default:
        break;
    }
  };

  return React.createElement(FrameBase, {
    useEcrionServer: true,
    url: url,
    width: width,
    height: height,
    namespace: "ContactActivity",
    on: onEvent,
    style: {
      minHeight: 300
    }
  });
};

ContactActivityPreview.defaultProps = {
  width: '100%',
  height: 'auto'
};
export default ContactActivityPreview;